<template>
	<div>
		<div class="actDiv">
			<label>小区</label>
				<a-select  style="width:9rem; margin: 0 0.425rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区" label-in-value
									option-filter-prop="children"  :filter-option="filterOption" show-search allowClear>
					<a-select-option v-for="(item) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
				</a-select>
				<a-tooltip placement="topLeft" title="默认时间2000年到今天" arrow-point-at-center>
					<a-range-picker  style="font-size: 0.6875rem;"
					:format="dateFormat" @change="onChange" >
					</a-range-picker>
				</a-tooltip>
				
				<a-select style="width:9rem; margin: 0 0.425rem;font-size: 0.6875rem;" v-model="dataForm.type" placeholder="请选择撤销方式" >
					<a-select-option v-for="item in nodeType" :key="item.type" :value="item.type" :label="item.type">{{item.nodeName}}</a-select-option>
				</a-select>
				<a-button size="small"   icon="search" @click="doQuery" style="margin: 0 0.425rem;">查询</a-button>
				<a-button  size="small"   @click="doPrint" style="margin: 0 0.425rem;" :disabled="isdoPrint" icon="printer">打印</a-button>
		</div>
		<vxe-table  align="center" :data="undoStatisList"  border max-height="600"  ref="mTable" show-overflow="title" size="mini"
						  resizable highlight-hover-row :loading="loading"  row-id="pid"
						  @checkbox-all="selectAllEvent" @checkbox-change="selectChangeEvent"
						  :checkbox-config="{trigger: 'row', highlight: true, range: true}">
				 <vxe-table-column type="seq" width="45"></vxe-table-column>
				 <vxe-table-column type="checkbox"  width="60"></vxe-table-column>
				 <vxe-table-column title="用户号" field="c_num" ></vxe-table-column>
				 <vxe-table-column title="用户名" field="CustomerName"></vxe-table-column>
				 <vxe-table-column title="地址" field="customerAddr" ></vxe-table-column>
				  <vxe-table-column title="手机" field="customerMobile"></vxe-table-column>
				  <vxe-table-column title="缴费/扣费时间" field="recordtime" ></vxe-table-column>
				  <vxe-table-column title="余额" field="customerBalance"></vxe-table-column>
				  <vxe-table-column title="操作" field="adminName">
					  <template #default="{ row }">
							<span v-if="row.targettype==1" style="background-color:#ffff99;">交费撤销</span>
							<span v-else style="background-color:#B4EEB4;">扣费撤销</span>
					  </template>
				  </vxe-table-column>
				  <vxe-table-column title="操作金额" field="Amount"></vxe-table-column>
				  <vxe-table-column title="操作人" field="adminname"></vxe-table-column>
				  <vxe-table-column title="撤销时间" field="actiontime"></vxe-table-column>
		</vxe-table>					
	</div>
</template>

<script>
import moment from 'moment';
export default{
	created() {
			this.queryNeighbors();
			this.createTime();
	},
	data(){
		return{
			isdoPrint:true,
			neighborName:null,
			dateFormat: 'YYYY-MM-DD',
			loading:false,
			undoStatisList:[],
			dateEnd:null,
			dateStart:"2000-01-01",
			nodeType:[
				{
				type:0,
				nodeName:'全部'
				},
				{
				type:1,
				nodeName:'交费撤销'
				},
				{
				type:2,
				nodeName:'扣费撤销'
				},
			],
			dataForm:{
				type:0
			},
			theNeighbor:undefined,
			neighborList:[],
			pids:[],
		}
	},
	methods:{
		moment,
		createTime:function(){
			this.dateStart="2000-01-01";
			this.dateEnd=new Date().toLocaleDateString();
		},
		changeDate:function (data) {
			var date = new Date(data)
			var Y = date.getFullYear() + '-'
			var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
			var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
			var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
			var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
			var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
			return Y + M + D + h + m + s;
		},
		selectAllEvent ({ checked, records }) {
			if(checked){
				for(var i = 0;i<records.length;i++){
					this.pids.push(records[i].pid);
				}
			}else{
				this.pids = [];
			}
		},
		selectChangeEvent({ checked, records }) {
			this.pids = [];
			for(var i = 0;i<records.length;i++){
				this.pids.push(records[i].pid);
			}
		},
		doPrint:function(){
			let url = null;
			let userId = this.Config.getUserLocal().pId;
			this.neighborName=this.theNeighbor.label;
			if(this.pids.length>0){
				let pidStr = this.pids.join(",");
				url = this.Api.getLastUrl('/report/undoLogChosedReport');
				window.open(url+'?userId='+userId+"&neighbor="+this.neighborName+"&pIds="+pidStr, "_blank");
			}else{
				url = this.Api.getLastUrl('/report/undoLogListReport');
				window.open(url+'?userId='+userId+"&neighbor="+this.neighborName, "_blank");
			}	
		},
		doQuery:function(){
			this.isdoPrint=true;
			if(this.theNeighbor==undefined||this.theNeighbor==null){
				this.$message.error("请选择小区");
			}else if(this.dateStart==null||this.dateEnd==null){
				this.$message.error("请选择时间范围");
			}
			else{
				this.undoStatisList=[];

				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.Static_LIST_Undo_URL);		
				let userId = this.Config.getUserLocal().pId;
				let param = {userId:userId,neighborId:this.theNeighbor.key,type:this.dataForm.type,startTime:this.dateStart,endTime:this.dateEnd};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						result.forEach(element => {
							element.recordtime=this.changeDate(element.recordtime);
							element.actiontime=this.changeDate(element.actiontime);
						});
						this.undoStatisList = result;
						this.isdoPrint=false;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.loading = false;
				});
			}
		},
		onChange(date, dateString) {
			this.dateStart=dateString[0];
			this.dateEnd=dateString[1];
			console.log(this.dateStart+"---------"+this.dateEnd);
    },
		queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			scrollSome:function(){
				this.$refs.mTable.refreshScroll();
			},
			cellClassName({ row, rowIndex, column }){
				let style = {
					color:'#000',
				};
				return style;
			}
	}
}
</script>

<style>
</style>
